// Redirect old /affiliate and /affiliate-terms URLs to new /reseller and /reseller-terms
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const RouteRedirects = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path === "/affiliate" || path.startsWith("/affiliate/")) {
      navigate(path.replace("/affiliate", "/reseller") + location.search, { replace: true });
    } else if (path === "/affiliate-terms" || path.startsWith("/affiliate-terms/")) {
      navigate(path.replace("/affiliate-terms", "/reseller-terms") + location.search, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default RouteRedirects;